import React from 'react';
import { Card, Image, Typography, Divider } from 'antd';
import { MailOutlined, CodeOutlined, InfoCircleOutlined } from '@ant-design/icons';
import LiftLogicLogo from '../../../assets/app_config/lift_logic_logo.png';
import { APP_VERSION } from 'config';
import Changelog from '../../../features/Changelog/Changelog';
import { useTenantBranding } from 'providers/Tenant/TenantBrandingProvider';

function Footer() {
  const { branding } = useTenantBranding();
  const tenantName = branding?.organization || 'Stiltech';
  return (
    <Card className="mt-4 shadow-sm border-0 bg-gradient-to-r from-gray-50 to-gray-100">
      <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
        {/* Logo y información principal */}
        <div className="flex items-center space-x-4">
          <div className="bg-white p-3 rounded-lg shadow-sm">
            <Image src={LiftLogicLogo} width={80} preview={false} />
          </div>
          <div className="flex flex-col">
            <Typography.Title level={5} className="mb-1 text-gray-800">
              {tenantName} - Sistema de Gestión
            </Typography.Title>
            <Typography.Text type="secondary" className="text-sm">
              Desarrollado por STIL
            </Typography.Text>
          </div>
        </div>

        {/* Información de contacto y versión */}
        <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-6">
          <div className="flex items-center space-x-2">
            <MailOutlined className="text-blue-600" />
            <Typography.Text className="text-sm text-gray-600">
              david.silva@liftlogic.cl
            </Typography.Text>
          </div>

          <div className="flex items-center space-x-2">
            <CodeOutlined className="text-green-600" />
            <Typography.Text className="text-sm text-gray-600">v{APP_VERSION}</Typography.Text>
          </div>
        </div>
      </div>

      <Divider className="my-4" />

      {/* Changelog */}
      <div className="flex justify-center">
        <div className="flex items-center space-x-2 text-gray-600">
          <InfoCircleOutlined className="text-blue-500" />
          <Typography.Text className="text-sm">Historial de cambios:</Typography.Text>
          <Changelog />
        </div>
      </div>
    </Card>
  );
}

export default Footer;
